import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { get, map } from "lodash";
import { withTranslation } from "react-i18next";

//i18n
import i18n from "../../../i18n";
import Flag from "react-flagkit";
import { useAppSelector } from "src/store";
import { LanguageDto } from "src/store/languages/types";
import { useDispatch } from "react-redux";
import { setLanguage } from "src/store/languages/languageSlice";

const LanguageDropdown = () => {
  const [menu, setMenu] = useState<boolean>(false);
  const dispatch = useDispatch();
  const language = useAppSelector((s) => s.language.language);
  const languageList = useAppSelector((s) => s.language.languages);

  const changeLanguageAction = async (lang: LanguageDto) => {
    i18n.changeLanguage(lang.Code.split("-")[0]);
    await localStorage.setItem("I18N_LANGUAGE", lang.Code.split("-")[0]);
    await dispatch(setLanguage(lang));
    window.location.reload();
  };
  const toggle = () => {
    setMenu(!menu);
  };

  return (
    <>
      <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block">
        <DropdownToggle className="btn header-item " tag="button">
          <Flag
            country={language?.Code?.split("-")[1].toUpperCase()}
            size={20}
          />
        </DropdownToggle>
        <DropdownMenu className="language-switch dropdown-menu-end">
          {map(
            languageList.filter(
              (x) => x.Code === "tr-TR" || x.Code === "en-US"
            ),
            (lang) => (
              <DropdownItem
                key={lang.EnumId}
                onClick={() => changeLanguageAction(lang)}
                className={`notify-item ${
                  language.EnumId === lang.EnumId ? "active" : "none"
                }`}
              >
                <Flag
                  country={lang?.Code?.split("-")[1].toUpperCase()}
                  size={18}
                />
                <span className="align-middle">{lang.Name}</span>
              </DropdownItem>
            )
          )}
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

export default withTranslation()(LanguageDropdown);
